import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pvp-swords",
  "use": "pvp-swords-usage",
  "viewBox": "0 0 30 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 28\" id=\"pvp-swords\">\n    <path d=\"M24.029 18.849l2.485-2.485 1.592 1.592-2.881 2.881L30 25.612 27.612 28l-4.775-4.775-2.882 2.882-1.59-1.593 2.484-2.485L3.55 4.73 2 0l4.731 1.548 17.298 17.3z\" />\n    <path d=\"M9.15 22.03l2.486 2.485-1.592 1.592-2.881-2.882L2.388 28 0 25.613l4.775-4.775-2.881-2.882 1.592-1.592 2.485 2.485 17.298-17.3L28 0l-1.548 4.731L9.15 22.03z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol